import { TimePicker } from "components/designV2/timePicker/timePicker";
import { useTranslation } from "react-i18next";
import {
  PassInputSeparator,
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";
import {
  DEFAULT_END_TIME,
  DEFAULT_START_TIME,
  fromTimePickerValue,
  toTimePickerValue,
} from "./companySystemSettings.logic";

export const TimeSettings: React.FC<{
  startTime: string;
  endTime: string;
  onChangeStartTime: (v: string) => void;
  onChangeEndTime: (v: string) => void;
}> = ({ startTime, endTime, onChangeStartTime, onChangeEndTime }) => {
  const { t } = useTranslation();
  return (
    <SystemSettingRow
      title={t("System.ShiftDefaultTime")}
      description={t("System.ShiftDefaultTimeInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <TimePicker
            ariaLabel={t("StampClock.StartTime")}
            value={toTimePickerValue(startTime, DEFAULT_START_TIME)}
            size="compact"
            onChange={(value) =>
              onChangeStartTime(fromTimePickerValue(value, startTime))
            }
          />
        </PassSettingControl>
        <PassInputSeparator aria-hidden="true" />
        <PassSettingControl>
          <TimePicker
            ariaLabel={t("StampClock.EndTime")}
            value={toTimePickerValue(endTime, DEFAULT_END_TIME)}
            size="compact"
            onChange={(value) =>
              onChangeEndTime(fromTimePickerValue(value, endTime))
            }
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
